import React from 'react';
import { Link } from 'react-router-dom';
import { FaDumbbell, FaFire, FaHeart, FaTrophy, FaYoutube, FaArrowRight } from 'react-icons/fa';
import transformPhoto from '../assets/transform.png';
import AdComponent from '../components/AdComponent';

const Home = ({ YOUTUBE_CHANNEL, INSTAGRAM_PROFILE }) => {
  const whatsappGroupLink = 'https://chat.whatsapp.com/CAsrkjCEANc4f9unrUxkn0';
  
  return (
    <div className="min-h-screen bg-black">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-yellow-500 via-orange-500 to-red-600 overflow-hidden">
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16 lg:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Left Content */}
            <div className="text-white">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 uppercase tracking-wide">
                Transform Your
                <span className="block text-yellow-300">Body & Mind</span>
              </h1>
              <p className="text-base sm:text-lg lg:text-xl mb-6 sm:mb-8 text-gray-200">
                Professional fitness training with Coach Sabari. Build strength, lose fat, and achieve your dream physique with personalized workout plans.
              </p>
              
              <div className="flex flex-wrap gap-4 mb-8">
                <Link
                  to="/workout-plans"
                  className="bg-black hover:bg-gray-900 text-yellow-400 px-8 py-4 rounded-lg font-bold uppercase tracking-wide transition-all transform hover:scale-105 border-2 border-yellow-400 flex items-center space-x-2"
                >
                  <FaDumbbell />
                  <span>Get Started</span>
                  <FaArrowRight />
                </Link>
                <a
                  href={whatsappGroupLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg font-bold uppercase tracking-wide transition-all transform hover:scale-105 border-2 border-green-500 flex items-center space-x-2"
                >
                  <FaHeart />
                  <span>Join Community</span>
                </a>
                <a
                  href={YOUTUBE_CHANNEL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg font-bold uppercase tracking-wide transition-all transform hover:scale-105 border-2 border-red-500 flex items-center space-x-2"
                >
                  <FaYoutube />
                  <span>Watch Videos</span>
                </a>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-3 gap-2 sm:gap-4">
                <div className="bg-black/60 backdrop-blur-sm p-2 sm:p-4 rounded-lg border border-yellow-500/50">
                  <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-yellow-400">380+</div>
                  <div className="text-xs sm:text-sm text-gray-300">Subscribers</div>
                </div>
                <div className="bg-black/60 backdrop-blur-sm p-2 sm:p-4 rounded-lg border border-orange-500/50">
                  <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-orange-400">80+</div>
                  <div className="text-xs sm:text-sm text-gray-300">Videos</div>
                </div>
                <div className="bg-black/60 backdrop-blur-sm p-2 sm:p-4 rounded-lg border border-red-500/50">
                  <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-red-400">94K+</div>
                  <div className="text-xs sm:text-sm text-gray-300">Views</div>
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative mt-8 lg:mt-0">
              <img
                src={transformPhoto}
                alt="Fitness Transformation"
                className="w-full h-[300px] sm:h-[400px] lg:h-[800px] object-cover rounded-2xl shadow-2xl border-4 border-yellow-400"
              />
              <div className="absolute -bottom-4 -left-4 sm:-bottom-6 sm:-left-6 bg-yellow-500 text-black p-3 sm:p-6 rounded-xl shadow-2xl border-2 sm:border-4 border-yellow-400">
                <div className="text-2xl sm:text-3xl font-bold">3+</div>
                <div className="text-xs sm:text-sm font-semibold">Years Experience</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Ad Unit */}
      <div className="bg-black py-4 px-4 flex justify-center">
        <AdComponent />
      </div>

      {/* Features Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-yellow-400 uppercase tracking-wide mb-3 sm:mb-4">
              Why Choose Coach Sabari?
            </h2>
            <p className="text-gray-400 text-base sm:text-lg">
              Professional training with proven results
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                icon: FaDumbbell,
                title: 'Expert Training',
                description: 'Personalized workout plans designed for your goals',
                color: 'yellow'
              },
              {
                icon: FaFire,
                title: 'Fat Loss',
                description: 'Proven methods to burn fat and get lean',
                color: 'orange'
              },
              {
                icon: FaTrophy,
                title: 'Muscle Gain',
                description: 'Build strength and size with progressive overload',
                color: 'red'
              },
              {
                icon: FaHeart,
                title: 'Nutrition',
                description: 'Complete diet plans for optimal results',
                color: 'yellow'
              }
            ].map((feature, index) => (
              <div
                key={index}
                className={`bg-black border-2 border-${feature.color}-500/50 rounded-xl p-6 hover:border-${feature.color}-400 transition-all transform hover:scale-105`}
              >
                <div className={`bg-gradient-to-r from-${feature.color}-500 to-${feature.color}-600 w-16 h-16 rounded-lg flex items-center justify-center mb-4`}>
                  <feature.icon className="text-black text-2xl" />
                </div>
                <h3 className={`text-xl font-bold text-${feature.color}-400 uppercase mb-2`}>
                  {feature.title}
                </h3>
                <p className="text-gray-400 text-sm">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-r from-yellow-500 via-orange-500 to-red-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-black uppercase tracking-wide mb-4 sm:mb-6">
            Ready to Start Your Transformation?
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-900 mb-6 sm:mb-8">
            Join hundreds of people who have transformed their bodies and lives
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/contact"
              className="bg-black hover:bg-gray-900 text-yellow-400 px-8 py-4 rounded-lg font-bold uppercase tracking-wide transition-all transform hover:scale-105 border-2 border-black"
            >
              Contact Me Now
            </Link>
            <Link
              to="/workout-plans"
              className="bg-white hover:bg-gray-100 text-black px-8 py-4 rounded-lg font-bold uppercase tracking-wide transition-all transform hover:scale-105 border-2 border-white"
            >
              View Workout Plans
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
